/**
 * 销售主管 - 商户管理 - 商户列表（团队商户）
 */
<template>
  <div class="sales-supervisor-merchant">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/salesSupervisor/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商户管理</el-breadcrumb-item>
      <el-breadcrumb-item>商户列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <div class="search-section">
      <el-form :inline="true" :model="formInline" size="small" class="search-form">
        <el-form-item label="商户类型">
          <el-select
            v-model="formInline.agentType"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(val, index) in merchantTypeList"
              :label="val.label"
              :value="val.value"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户名称">
          <el-input
            v-model="formInline.merchantName"
            placeholder="请输入商户名称（支持模糊搜索）"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务商">
          <el-input
            v-model="formInline.disCompanyName"
            placeholder="请输入服务商名称（支持模糊搜索）"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="电销">
          <el-select
            v-model="formInline.phoneSalesId"
            placeholder="请选择电销"
            clearable
          >
            <el-option
              v-for="item in salesOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="面销">
          <el-select
            v-model="formInline.faceSalesId"
            placeholder="请选择面销"
            clearable
          >
            <el-option
              v-for="item in salesOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- T-011: REQ-003 F04(主管) 新增转交电销/转交面销下拉,数据源=本团队销售(salesOptions=getTeamSalesList),字面字段 ID 等值(后端 T-007 已支持),可清空与既有筛选并存 -->
        <el-form-item label="转交电销">
          <el-select
            v-model="formInline.transferPhoneSalesId"
            placeholder="请选择转交电销"
            clearable
          >
            <el-option
              v-for="item in salesOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转交面销">
          <el-select
            v-model="formInline.transferFaceSalesId"
            placeholder="请选择转交面销"
            clearable
          >
            <el-option
              v-for="item in salesOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属地">
          <el-select
            v-model="formInline.phoneSalesLocation"
            placeholder="全部"
            clearable
          >
            <el-option label="北京" value="北京"></el-option>
            <el-option label="石家庄" value="石家庄"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="返点">
          <el-select
            v-model="formInline.hasRebate"
            placeholder="全部"
            clearable
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="formInline.date"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 导出 / 检索按钮（位置保持不变） -->
    <div class="toolbar">
      <el-button type="primary" size="small" icon="el-icon-download" @click="exportdata">导出数据</el-button>
      <el-button type="primary" size="small" icon="el-icon-search" @click="onSearchMerchants">检索商户</el-button>
    </div>

    <!-- 列表 -->
    <el-card shadow="hover" class="table-card">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="加载中..."
        empty-text="暂无数据"
        style="width: 100%"
      >
      <el-table-column
        fixed
        prop="merchantName"
        label="商户名称"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="agentType" label="类型" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ getAgentTypeLabel(scope.row.merchantType) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="phoneSalesName" label="电销" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="faceSalesName" label="面销" show-overflow-tooltip>
      </el-table-column>
      <!-- T-005: REQ-002 F004 追加转交两列(原有列保留, 只读无转交入口, 未转交显示"--") -->
      <el-table-column prop="transferPhoneSalesName" label="转交电销" min-width="110" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.transferPhoneSalesName || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="transferFaceSalesName" label="转交面销" min-width="110" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.transferFaceSalesName || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="industry" label="所属行业" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="managementFeeRate"
        label="管理费率"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ formatRate(scope.row.managementFeeRate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="actualQuotePrice"
        label="实际报价"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ formatRate(scope.row.actualQuotePrice) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="rebate" label="返点" show-overflow-tooltip>
        <template slot-scope="scope">
          <span
            :style="{
              color:
                scope.row.rebate != null &&
                scope.row.rebate !== '' &&
                Number(scope.row.rebate) !== 0
                  ? '#f56c6c'
                  : '#909399',
            }"
          >
            {{ formatRate(scope.row.rebate) || '0.00%' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="distributeCompanyName"
        label="下发公司"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="signDate"
        label="签约时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="startDate"
        label="启动时间"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>

      <!-- 分页组件 -->
      <Pagination
        v-bind:child-msg="pageparm"
        @callFather="callFather"
        class="pagination-wrap"
      ></Pagination>
    </el-card>

    <el-dialog title="检索商户" :visible.sync="dialogTableVisible">
      <el-table :data="dialogTableData" size="small">
        <el-table-column
          property="companyName"
          label="商户名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          property="status"
          label="签约状态"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span
              :style="{
                color: scope.row.status === '已签约' ? '#67C23A' : '#F56C6C',
              }"
            >
              {{ scope.row.status }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { getSalesTeamMerchants, getTeamSalesList, searchMerchants } from '../../api/userMG';
import Pagination from '../../components/Pagination';

export default {
  name: 'SalesSupervisorMerchantList',
  components: {
    Pagination,
  },
  data() {
    return {
      merchantTypeList: [
        { label: '普通商户', value: 1 },
        { label: '代理商户', value: 2 },
      ],
      salesOptions: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      loading: false,
      dialogTableData: [],
      dialogTableVisible: false,
      formInline: {
        page: 1,
        pageSize: 10,
        merchantName: '',
        disCompanyName: '',
        phoneSalesId: null,
        faceSalesId: null,
        // T-011: REQ-003 F04(主管) 转交电销/转交面销下拉(字面字段 ID 等值, 数据源=本团队销售)
        transferPhoneSalesId: null,
        transferFaceSalesId: null,
        phoneSalesLocation: '',
        startDate: '',
        endDate: '',
        agentType: '',
        hasRebate: '',
        date: [],
      },
      listData: [],
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  created() {
    this.fetchSalesOptions();
    this.getdata(this.formInline);
  },
  methods: {
    onSearchMerchants() {
      this.$prompt('请输入检索商户', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[\s\S]{1,100}$/,
        inputErrorMessage: '请输入有效的商户名称',
      })
        .then(({ value }) => {
          const trimmedValue = value.trim();
          searchMerchants({ merchantName: trimmedValue }).then((res) => {
            if (res.msg === 'success') {
              this.dialogTableVisible = true;
              if (res.data && res.data.length > 0) {
                this.dialogTableData = res.data.map((item) => ({
                  companyName: item.companyName,
                  status: '已签约',
                }));
              } else {
                this.dialogTableData = [
                  { companyName: trimmedValue, status: '未签约' },
                ];
              }
            } else {
              this.$message({ type: 'error', message: res.msg });
            }
          });
        })
        .catch(() => {
          this.$message({ type: 'info', message: '取消输入' });
        });
    },
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        merchantName: '',
        disCompanyName: '',
        phoneSalesId: null,
        faceSalesId: null,
        transferPhoneSalesId: null,
        transferFaceSalesId: null,
        phoneSalesLocation: '',
        agentType: '',
        hasRebate: '',
        date: [],
      };
      this.getdata(this.formInline);
    },
    fetchSalesOptions() {
      // BUG-001: 去掉 status=1 在职过滤 → 下拉含团队内离职销售(后端 listTeamMembersPage 不传 status 默认 status!=9), 主管仅可见本团队销售
      getTeamSalesList({ page: 1, pageSize: 9999, saleName: '' })
        .then((res) => {
          if (res && (res.msg === 'success' || res.code === 0)) {
            const data = res.data || {};
            this.salesOptions = Array.isArray(data.items) ? data.items : [];
          } else {
            this.salesOptions = [];
          }
        })
        .catch(() => {
          this.salesOptions = [];
        });
    },
    getdata(formInline) {
      this.loading = true;
      const params = {
        page: formInline.page,
        pageSize: formInline.pageSize,
        disCompanyName: formInline.disCompanyName,
        merchantName: formInline.merchantName,
        phoneSalesId: formInline.phoneSalesId,
        faceSalesId: formInline.faceSalesId,
        // T-011: REQ-003 F04(主管) 转交电销/转交面销透传(字面字段 ID 等值, 后端 T-007 已支持)
        transferPhoneSalesId: formInline.transferPhoneSalesId,
        transferFaceSalesId: formInline.transferFaceSalesId,
        phoneSalesLocation: formInline.phoneSalesLocation,
        startDate: formInline.startDate,
        endDate: formInline.endDate,
        agentType: formInline.agentType,
        hasRebate: formInline.hasRebate === '' ? undefined : formInline.hasRebate,
      };
      getSalesTeamMerchants(params)
        .then((res) => {
          this.loading = false;
          if (res.msg === 'success' || res.code === 0) {
            const data = res.data || {};
            this.listData = Array.isArray(data.items) ? data.items : [];
            this.pageparm.page = data.page != null ? data.page : formInline.page;
            this.pageparm.pageSize = data.pageSize != null ? data.pageSize : formInline.pageSize;
            this.pageparm.total = data.totalCount != null ? data.totalCount : 0;
          } else {
            this.$message({ type: 'error', message: res.msg || '请求失败' });
            this.listData = [];
          }
        })
        .catch(() => {
          this.loading = false;
          this.listData = [];
        });
    },
    exportdata() {
      const params = {
        page: 1,
        pageSize: 99999,
        merchantName: this.formInline.merchantName,
        disCompanyName: this.formInline.disCompanyName,
        phoneSalesId: this.formInline.phoneSalesId,
        faceSalesId: this.formInline.faceSalesId,
        // T-011: REQ-003 F04(主管) 导出保持与搜索一致(透传转交电销/转交面销)
        transferPhoneSalesId: this.formInline.transferPhoneSalesId,
        transferFaceSalesId: this.formInline.transferFaceSalesId,
        phoneSalesLocation: this.formInline.phoneSalesLocation,
        startDate: this.formInline.startDate,
        endDate: this.formInline.endDate,
        agentType: this.formInline.agentType,
        hasRebate: this.formInline.hasRebate === '' ? undefined : this.formInline.hasRebate,
        export: 1,
      };
      getSalesTeamMerchants(params)
        .then((res) => {
          if (res.msg === 'success' || res.code === 0) {
            if (res.data && res.data.downloadUrl) {
              window.open(res.data.downloadUrl);
            } else {
              this.$message({ type: 'error', message: '导出链接为空，请联系管理员' });
            }
          } else {
            this.$message({ type: 'error', message: res.msg || '导出失败' });
          }
        })
        .catch(() => {
          this.$message({ type: 'error', message: '导出失败' });
        });
    },
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    search() {
      if (this.formInline.date && this.formInline.date.length === 2) {
        this.formInline.startDate = this.formInline.date[0] || '';
        this.formInline.endDate = this.formInline.date[1] || '';
      } else {
        this.formInline.startDate = '';
        this.formInline.endDate = '';
      }
      this.formInline.page = 1;
      this.getdata(this.formInline);
    },
    getAgentTypeLabel(agentType) {
      const type = this.merchantTypeList.find((item) => item.value === agentType);
      return type ? type.label : '未知';
    },
    formatRate(rate) {
      if (rate != null && rate !== undefined) {
        return `${(parseFloat(rate) * 100).toFixed(2)}%`;
      }
      return '';
    },
  },
};
</script>

<style scoped>
.sales-supervisor-merchant {
  padding-bottom: 24px;
}
.page-breadcrumb {
  margin-bottom: 0;
}

.search-section {
  margin-top: 24px;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.search-form .el-form-item {
  margin-bottom: 10px;
  margin-right: 20px;
}
.search-form .search-input {
  width: 220px;
}

.toolbar {
  margin: 16px 0;
}
.toolbar .el-button + .el-button {
  margin-left: 10px;
}

.table-card {
  border-radius: 8px;
  overflow: hidden;
}
.table-card >>> .el-card__body {
  padding: 20px;
}
.pagination-wrap {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/salesSupervisor/merchantList.vue